// extracted by mini-css-extract-plugin
module.exports = {"root":"NoOpportunitySelected__root___FnYX6","content":"NoOpportunitySelected__content___gFXns"};